// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editFieldGroup-container .editFieldGroup-title {
  background-color: #F5F9FF;
  padding: 10px 20px;
  -webkit-user-select: none;
          user-select: none;
  font-weight: bold;
  color: #6A8991;
  font-size: 14px;
  font-weight: 500;
  border-top: 1px solid #D3E1ED;
  border-bottom: 1px solid #D3E1ED;
}
.editFieldGroup-container .editFieldGroup-fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 50px;
  padding: 25px;
}`, "",{"version":3,"sources":["webpack://./src/components/EditFieldGroup/EditFieldGroup.scss"],"names":[],"mappings":"AACC;EACC,yBAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,gCAAA;AAAF;AAGC;EACC,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,aAAA;AADF","sourcesContent":[".editFieldGroup-container {\n\t.editFieldGroup-title {\n\t\tbackground-color: #F5F9FF;\n\t\tpadding: 10px 20px;\n\t\tuser-select: none;\n\t\tfont-weight: bold;\n\t\tcolor: #6A8991;\n\t\tfont-size: 14px;\n\t\tfont-weight: 500;\n\t\tborder-top: 1px solid #D3E1ED;\n\t\tborder-bottom: 1px solid #D3E1ED;\n\t}\n\n\t.editFieldGroup-fields {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1fr 1fr;\n\t\tcolumn-gap: 50px;\n\t\tpadding: 25px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
